/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Api key creation request
 */
export interface LakeApiKeyCreationRequest {
  name: string;
  accountId: number;
  permission: LakeApiKeyCreationRequest.PermissionEnum;
  /**
   * Optional CIDR block to restrict keys to. E.g. a.b.c.0/24. Blank - allow all IPs.
   */
  cidr?: string;
}
export namespace LakeApiKeyCreationRequest {
  export const PermissionEnum = {
    Create: 'CREATE',
    Read: 'READ',
  } as const;
  export type PermissionEnum = (typeof PermissionEnum)[keyof typeof PermissionEnum];
}
